<template>
    <div>
        <div :class="`mb-2 ${classList.input}`" v-if="showTemplateTypeahead">
            <NewTypeahead
                v-model:selectedOption="selectedTemplate"
                :fetchOptions="getTemplateList"
                placeholder="Search for Template"
                :searchCharLimit="3"
                :disabled="disabled"
            />
        </div>
        <div :class="`mb-2 ${classList.input}`" v-if="showTemplateDropdown">
            <select class="form-select" v-model="selectedTemplate">
                <option selected :value="null">--Select Template--</option>
                <option v-for="template in templates" :value="template" :key="template.id">{{ template.name }}</option>
            </select>
        </div>
        <div class="form-group">
            <textarea
                :class="`form-control ${classList.textarea}`"
                rows="4"
                :name="inputName"
                :value="result"
                :placeholder="placeholder"
                :disabled="disabled"
                :maxlength="maxLength"
                @input="updateResult(($event.target as any).value)"
            ></textarea>
            <p :class="`mb-0 ${maxLength === result?.length ? 'text-danger' : ''}`" v-if="maxLength !== maxCharLimit">
                You have {{ maxLength - (result ? result.length : 0) }} remaining characters.
            </p>
        </div>
    </div>
</template>

<script lang="ts" src="./CommentInput"></script>
